/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GeoItemSearchAreaInput = {
  geometry: Types.JsonObject;
  mode: GeoItemSearchAreaMode;
};

export type GeoItemSearchAreaMode =
  | 'contains'
  | 'covers'
  | 'intersects'
  | 'within';

export type GeoItemSearchInput = {
  area?: GeoItemSearchAreaInput | null | undefined;
  label?: string | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  statuses?: Array<GeoItemSearchStatus> | null | undefined;
  tenantId: string;
};

export type GeoItemSearchStatus =
  | 'deactivated'
  | 'draft'
  | 'init'
  | 'published';

export type SearchGeoItemsInAreaQueryVariables = Exact<{
  input: Types.GeoItemSearchInput;
}>;


export type SearchGeoItemsInAreaQuery = { cnutSearchGeoItems: { __typename: 'GeoItemSearchOutput', total: number, items: Array<{ __typename: 'GeoItemSearchItemOutput', id: string, coords: Types.JsonObject | null, i18nLabel: Types.JsonObject }> } };


export const SearchGeoItemsInAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchGeoItemsInArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoItemSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutSearchGeoItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coords"}},{"kind":"Field","name":{"kind":"Name","value":"i18nLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SearchGeoItemsInAreaQuery, SearchGeoItemsInAreaQueryVariables>;